import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import Spinner from '../../../shared/spinner.component';
import ParamForm from '../shared/ParamForm.component';

import { paramsPropTypes } from '../shared/propTypes';
import { OptionsPropType } from '../../../shared/propTypes/common';

import EditCustomReportQueryParamModal from './editCustomReportQueryParamModalContainer.component';

class TestCustomReportQueryForm extends PureComponent {
  static propTypes = {
    params: paramsPropTypes,
    queryParams: PropTypes.objectOf(PropTypes.string.isRequired),
    customReportParamsOptions: PropTypes.objectOf(OptionsPropType),

    readOnly: PropTypes.bool.isRequired,
    isFetchingCustomReportParams: PropTypes.bool.isRequired,
    wasVerifyingCustomReportParamQuerySuccessful: PropTypes.bool.isRequired,

    updateQueryParams: PropTypes.func.isRequired,
    fetchCustomReportParams: PropTypes.func.isRequired,
    showCustomReportModalForParam: PropTypes.func.isRequired,
    hideCustomReportModalForParam: PropTypes.func.isRequired,
    updateParam: PropTypes.func.isRequired,

    customReportParamModalData: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      data: PropTypes.objectOf(PropTypes.string),
    }).isRequired,

    reportParamToEditOptions: OptionsPropType,

    testCustomReportQueryParamModalData: PropTypes.func.isRequired,
    showTestCustomReportQueryParamModal: PropTypes.func.isRequired,
    hideTestCustomReportQueryParamModal: PropTypes.func.isRequired,
    verifyParamOptionsQuery: PropTypes.func.isRequired,

    isVerifyingParamToEditQuery: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentParamName: null,
    };
  }

  componentDidMount() {
    this.fetchQueryParamsDropdownData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.params !== this.props.params || prevProps.queryParams !== this.props.queryParams) {
      this.fetchQueryParamsDropdownData();
    }
  }

  fetchQueryParamsDropdownData = debounce(() => {
    const {
      params,
      queryParams,
      fetchCustomReportParams,
    } = this.props;

    fetchCustomReportParams(params, queryParams);
  }, 1000);

  editParam = paramName => () => {
    const { showCustomReportModalForParam } = this.props;

    this.setState({
      currentParamName: paramName,
    });

    showCustomReportModalForParam({ paramName });
  };

  render() {
    const {
      queryParams,
      customReportParamsOptions,
      isFetchingCustomReportParams,
      readOnly,
      params,
      updateQueryParams,
      customReportParamModalData,
      hideCustomReportModalForParam,
      updateParam,
      reportParamToEditOptions,
      testCustomReportQueryParamModalData,
      showTestCustomReportQueryParamModal,
      hideTestCustomReportQueryParamModal,
      isVerifyingParamToEditQuery,
      verifyParamOptionsQuery,
    } = this.props;

    const paramsForm = params
      ? <ParamForm
        readOnly={readOnly}
        params={Object.values(params)}
        queryParams={queryParams}
        updateQueryParams={updateQueryParams}
        customReportParamsOptions={customReportParamsOptions}
        editParam={this.editParam}
      />
      : null;

    const entityToEdit = customReportParamModalData.data
      ? params[customReportParamModalData.data.paramName]
      : {};

    return (
      <div className="col-sm-12 col-lg-6">
        {isFetchingCustomReportParams ? <Spinner /> : paramsForm}
        <EditCustomReportQueryParamModal
          hideCustomReportModalForParam={hideCustomReportModalForParam}
          entityToEdit={entityToEdit}
          reportParamToEditOptions={reportParamToEditOptions}
          isVerifyingParamToEditQuery={isVerifyingParamToEditQuery}
          isVisible={customReportParamModalData.show}
          saveEntity={updateParam}
          verifyParamOptionsQuery={verifyParamOptionsQuery}
          testCustomReportQueryParamModalData={testCustomReportQueryParamModalData}
          showTestCustomReportQueryParamModal={showTestCustomReportQueryParamModal}
          hideTestCustomReportQueryParamModal={hideTestCustomReportQueryParamModal}
        />
      </div>
    );
  }
}

export default TestCustomReportQueryForm;
